module.exports = __webpack_public_path__ + "public/img/promo-xhd.382eebab.jpg";